// Based on .env VITE_ENV_MODE
export const PRODUCTION_ENVS = ["staging", "platform"];
export const TEST_STAGING_ENV_MODE = "test";
export const TEST_DEV_ENV_MODE = "test-dev";
export const DEV_ENV_MODE = "development";

export type FlagName =
  | "FEATURE_TOUR"
  | "DASHBOARD_OVERVIEW_CUSTOMER"
  | "PHS_CUSTOMER_SEND_TEST_LURE"
  | "SEG"
  | "SEG_CHECKBOX"
  | "MSP_BRANDING"
  | "PHS_NOTIFY_MANAGER"
  | "CYBERSENTRIQ_ANNOUNCEMENT_MODAL"
  | "INCIDENTS_V3_CATEGORIES"
  | "INCIDENTS_V3_MULTI_ACTIONS"
  | "REPORT_MANAGER_PHS_USER_REPORT"
  | "FRONTLINE_CHECKS"
  | "GEOBLOCKING"
  | "MSP_OVERVIEW_CHART";

type Config = {
  [K in FlagName]: {
    dev: boolean;
    testDev: boolean;
    testStaging: boolean;
    prod: boolean;
  };
};

export const FLAGS_CONFIG: Config = {
  FEATURE_TOUR: {
    dev: false,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  DASHBOARD_OVERVIEW_CUSTOMER: {
    dev: false,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1706
  PHS_CUSTOMER_SEND_TEST_LURE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1956
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1957
  SEG_CHECKBOX: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1994
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2290
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1958
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2351
  SEG: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2593
  MSP_BRANDING: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1240
  INCIDENTS_V3_CATEGORIES: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/566
  INCIDENTS_V3_MULTI_ACTIONS: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1668
  PHS_NOTIFY_MANAGER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  CYBERSENTRIQ_ANNOUNCEMENT_MODAL: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1766
  REPORT_MANAGER_PHS_USER_REPORT: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2351
  FRONTLINE_CHECKS: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2514
  GEOBLOCKING: {
    dev: true,
    testDev: true,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2656
  MSP_OVERVIEW_CHART: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
};
